module.exports = __webpack_public_path__ + "static/img/gift-17.95beacf.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-17.png
// module id = 361
// module chunks = 140